import { createAction, props } from '@ngrx/store';
import { EOrderSource } from 'src/app/models/data/sales-order.model';

export const loadOrderUis = createAction(
  '[OrderUi] Load OrderUis'
);


export const setUISelectedOrderStatus = createAction(
  '[OrderUI] Set UI Selected Order Status',
  props<{
    uiselectedOrderStatus: string[]
  }>()
)

export const setUISelectedOrderCustomerName = createAction(
  '[OrderUI] Set UI Selected Order Custoemr Name',
  props<{
    uiselectedOrderCustomerName: string[]
  }>()
)

export const clearUISelectedOrderCustomerName = createAction(
  '[OrderUI] Clear UI Selected Order Custoemr Name'
)

export const setUISelectedOrderProcessor = createAction(
  '[OrderUI] Set UI Selected Order Processor',
  props<{
    uiselectedOrderProcessor: string[]
  }>()
)

export const clearUISelectedOrderProcessor = createAction(
  '[OrderUI] Clear UI Selected Order Processor'
)

export const setUISelectedOrderCustomerCode = createAction(
  '[OrderUI] Set UI Selected Order Custoemr Code',
  props<{
    uiselectedOrderCustomerCode: string[]
  }>()
)

export const clearUISelectedOrderCustomerCode = createAction(
  '[OrderUI] Clear UI Selected Order Custoemr Code'
)

export const clearUISelectedOrderStatus = createAction(
  '[OrderUI] Clear UI Selected Order Status',
)

export const setUISelectedOrderCreator = createAction(
  '[OrderUI] Set UI Selected Order Creator',
  props<{
    uiselectedOrderCreator: string[]
    }>()
)

export const clearUISelectedOrderCreator = createAction(
  '[OrderUI] Clear UI Selected Order Creator',
)

export const setUISelectedOrderTimeRange = createAction(
  '[OrderUI] Set UI Selected Order Time Range',
  props<{
    uiselectedOrderTimeRange:number[]
  }>()
)

export const clearUISelectedOrderTimeRange = createAction(
  '[OrderUI] Clear UI Selected Order Time Range',
)

export const setUISelectedOrderId = createAction(
  '[OrderUI] Set UI Selected Order Id',
  props<{
    uiselectedOrderId: number
  }>()
)

export const clearUISelectedOrderId = createAction(
  '[OrderUI] Clear UI Selected Order Id',
)

export const setuiOrderDetailLoading = createAction(
  '[OrderUI] Set UI Order Detail Loading',
  props<{
    uiOrderDetailLoading:{
      loadingSwitch:boolean
      loadingTip?:string
    }
  }>()
)

export const clearuiOrderDetailLoading = createAction(
  '[OrderUI] Clear UI Order Detail Loading'
)

export const setUISearchPurchaserName = createAction(
  '[OrderUI] Set UI Search Purchaser Name',
  props<{
    uiSearchPurchaserName: string
  }>()
)

export const clearUISearchPurchaserName = createAction(
  '[OrderUI] Clear UI Search Purchaser Name',

)

export const setuiOrderListTableLoading = createAction(
  '[OrderUI] Set UI Order List Table Loading',
  props<{
    uiOrderListTableLoading:boolean
  }>()
)

export const clearuiOrderListTableLoading = createAction(
  '[OrderUI] Clear UI Order List Table Loading'
)

export const setUIPreviewOrderUploadLoading = createAction(
  '[OrderUI] Set UI Preview Order Upload Loading',
  props<{
    uiPreviewOrderUploadLoading: boolean
  }>()
)

export const clearUIPreviewOrderUploadLoading = createAction(
  '[OrderUI] Clear UI Preview Order Upload Loading',
)

export const setuiPreferenceSOCraeteLoading = createAction(
  '[OrderUI] Set UI Preference SO Craete Loading',
props<{
  uiPreferenceSOCraeteLoading:boolean
}>()
)

export const clearuiPreferenceSOCraeteLoading = createAction(
  '[OrderUI] Clear UI Preference SO Craete Loading'
)

export const setUISelectedOrderSource = createAction(
  '[OrderUI] Set UI Selected Order Source',
  props<{
    uiselectedOrderSource: EOrderSource[]
  }>()
)

export const clearUISelectedOrderSource = createAction(
  '[OrderUI] Clear UI Selected Order Source',
)

export const clearAllUiSelectedOrderFitler = createAction(
  '[OrderUI] Clear All Ui Selected Order Filter',
)
